import { render, staticRenderFns } from "./Tab-insert-invoice-Franchise.vue?vue&type=template&id=0002f1c6"
import script from "./Tab-insert-invoice-Franchise.vue?vue&type=script&lang=js"
export * from "./Tab-insert-invoice-Franchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports